import { useLocation } from 'react-router';

// rymi-TODO: useActualIncidentId() can return incidentId even when we are not in incident workspace context
// ideally, useActualIncidentId() should return null when we are in command center context
export const useIsCommandCenter = () => {
  const location = useLocation();

  return location.pathname === '/hub' || location.pathname === '/';
};
